import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from './Navbar';
import ImageGallery from './ImageGallery';
import './ProductDetail.css';
import { usePortfolioDetail } from '../hooks/usePortfolioDetail';
import { useImageExtraction } from '../hooks/useImageExtraction';

const ProductDetail: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const { portfolio, loading, error } = usePortfolioDetail(productId || '');


  useEffect(() => {
    // Disable page scrolling for immersive experience
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      // Restore scrolling when component unmounts
      document.body.style.overflow = 'auto';
      document.documentElement.style.overflow = 'auto';
    };
  }, []);

  if (loading ) {
    return (
      <div className="simplified-product-detail">
        <Navbar />
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="simplified-product-detail">
        <Navbar />
        <div className="error-container">
          <div className="error-message">
            {error}
          </div>
        </div>
      </div>
    );
  }

  if (!portfolio) {
    return (
      <div className="simplified-product-detail">
        <Navbar />
        <div className="error-container">
          <div className="error-message">
            Portfolio not found
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="simplified-product-detail">
      <Navbar />
      <ImageGallery
        images={portfolio.image_list}
        title={portfolio.title}
      />
    </div>
  );
};

export default ProductDetail;